<template>
	<div class="floatMenu">
		<chat-box ref="chatBox" :parentObj="this"></chat-box>
		<takeNotes></takeNotes>
		<scrollToTop></scrollToTop>
	</div>
</template>

<script>
	import chatBox from '@/components/ai/index.vue';
	import takeNotes from '@/components/takeNotes.vue';
	import scrollToTop from '@/components/scrollToTop.vue';
	
	export default {
		name: 'floatMenu',
		components: {
			chatBox,
			takeNotes,
			scrollToTop
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},

		methods: {
			
		}
	}
</script>

<style lang="scss" scoped>
	.floatMenu {
		position: fixed;
		right: 15px;
		bottom: 50px;
		background: #FFFFFF;
		box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
		border-radius: 20px;
		padding: 5px 5px 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		z-index: 99;
	}
</style>